import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './deleteEmailTemplateView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';

class DeleteEmailTemplateView extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      name : props.template.name,
    }
  
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedEmailTemplates = this.localizatedSettings.templates.email;
    this.localizedSliders = this.localizedEmailTemplates.sliders;
  }

  _handleDeleteClick() {
      var index = this.props.emailTemplates.findIndex((template) => {
      return template.id == this.props.template.id;
    })
    this.props.deleteEmailTemplate(this.props.template.id).then(() =>{
      if (this.props.onDeletion) {
        this.props.onDeletion();
      }

      var nextIndex = 0;
      if (index > 0) {
        var nextIndex = index++;

        if (nextIndex > this.props.emailTemplates.length - 1) {
          nextIndex = this.props.emailTemplates.length - 1;
        }
      }

      var nextEmailTemplate = this.props.emailTemplates[nextIndex];
      if (nextEmailTemplate) {
        this.props.navigate(`/settings/email-template/${nextEmailTemplate.id}`);  
      } else {
        this.props.navigate(`/settings/email-template`);
      }
    });
  }

  _handleCancelClick(){
    if(this.props.onCancel){
      this.props.onCancel();
    }

  }

  render() {
    return (     
      <div className={ styles.content }>
        <Row className={ styles.top }>
            <Col sm={8} className={styles.column}>
                <div className={styles.heading}>{this.localizedSliders.title}</div>
                <div className={styles.label}>
                  1 {this.localizedSliders.sub_text}
                </div>
                
                <p className={styles.description}>
                {this.localizedSliders.description}
                </p>
            </Col> 
            <Col sm={12} className={styles.column}>   
                <div className={styles.templateNameContainer}>
                  {this.state.name}
                </div>
            </Col>
        </Row>
        <div className={styles.buttonTray}>
            <Button
              text={this.props.deleting ? `${this.localizedCommonActions.deleting}...` : this.localizedCommonActions.confirm}
              disabled= {this.props.deleting}
              variant='primary'
              className={styles.send}
              onClick={() => {this._handleDeleteClick()}}
              >
            </Button>
            <Button
              variant='secondary'
              text={this.localizedCommonActions.cancel}
              className={styles.cancel}
              onClick={() => {this._handleCancelClick()}}
              >
            </Button>
        </div>
      </div>
    );
  }

}
export default DeleteEmailTemplateView;
